module.exports = __webpack_public_path__ + "static/media/ic_informacion_pin.5bd598d8.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_informacion_pin.webp
// module id = 202
// module chunks = 1